import React, { Component } from 'react';

import NavBar from '../../components/navigation/NavBar';
import RateView from '../../components/rateview/RateView';

import { getCurrentResource } from '../../util/tools';
import { FORM_REQUEST_ITEM_TABLE } from '../../util/consts/forms';

class RequestItemListPage extends Component {
	
	constructor(props) {
		super(props);

		this.resource = getCurrentResource().pages.tableform.RequestItemList;
		let paramCacheId = props.match.params.param;

		this.rvContext = {
			form: FORM_REQUEST_ITEM_TABLE,
			data: []
		};
		this.rvOptions = {
			form: FORM_REQUEST_ITEM_TABLE,
			formTitle: this.resource.formTitle,
			paramCacheId: paramCacheId,
			transition: null,
			hideButtonAdd: true,
			hideButtonEdit: true,
			hideButtonMergeInstances: true,
			hideButtonChangeOwner: true,
			hideButtonFieldUpdate: true,
			hideButtonGlobalIdUpdate: true,
			hideButtonDelete: true,
			hideButtonShowHtml: true,
			hideButtonHtml: false,
			hideButtonPdf: true,
			hideButtonXml: true,
			//hideButtonTransition: true,
			hideButtonUshExport: true,
			hideButtonUshImport: true,
			hideButtonSendEmail: true,
			controlPanelTools: null,
		};
	}
	componentDidMount() {
		document.title = 'BOM. ' + this.resource.formTitle;
	}

	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<RateView rvContext={this.rvContext} rvOptions={this.rvOptions} app={this.props.app}  />
			</React.Fragment>
		)
	}
	
}

export default RequestItemListPage;
